module.exports = __webpack_public_path__ + "img/ms.7462eefa.svg";